import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { ProjectCompetitorsModel } from "../../models/ProjectCompetitorsModel";
import ProjectCompetitorsService from "../../services/ProjectCompetitorsService";
import ProjectCompetitorsSlice from "../slices/ProjectCompetitorsSlice";
import { RootState } from "../store";

export const ProjectCompetitorsActions = ProjectCompetitorsSlice.actions;
export const fetchProjectCompetitors = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(ProjectCompetitorsActions.setIsProjectCompetitorsFetching(true));
    const response: ProjectCompetitorsModel[] =
      await ProjectCompetitorsService.getAllProjectCompetitors();
    dispatch(ProjectCompetitorsActions.setProjectCompetitors(response));
    dispatch(ProjectCompetitorsActions.setIsProjectCompetitorsFetching(false));
  };
};
export const fetchParticularProjectCompetitor = (
  id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: ProjectCompetitorsModel =
      await ProjectCompetitorsService.getParticularProjectCompetitor(id);
    dispatch(
      ProjectCompetitorsActions.setParticularProjectCompetitor(response)
    );
  };
};
